import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MessageService } from 'primeng/api';
import { ApplicationService } from 'src/app/private/services/application.service';
import { LeadService } from 'src/app/private/services/lead.service';
import { SharedModule } from 'src/app/private/shared/shared.module';
import { LocalStorageService } from 'src/app/utils/LocalStorageService';

@Component({
  selector: 'app-bulk-delete-application',
  imports: [SharedModule],
  templateUrl: './bulk-delete-application.component.html',
  styleUrl: './bulk-delete-application.component.scss'
})
export class BulkDeleteApplicationComponent {

  @Output() closeDialog = new EventEmitter();
  @Input() selectedProducts: any[] = [];
  @Output() reload = new EventEmitter<any>();
  isLoading = false;

  constructor(
    private localStorage: LocalStorageService,
    private api: ApplicationService,
    private messageService: MessageService

  ) { }

  handleCloseDialog() {
    this.closeDialog.emit();
  }

  handleDelete() {

    const payload : any[] = [];
    this.selectedProducts.forEach((item) => {
      payload.push({
        organization_id: this.localStorage.getOrganizationId(),
        lead_id: item.lead_id,
        application_id: item.application_data?.application_id
      });
    });

    this.isLoading = true;
    this.api.deleteApplication(payload).subscribe({
      next: (response) => {
        this.isLoading = false;
        this.reload.emit();
        this.closeDialog.emit();
        this.messageService.add({
          severity: 'success',
          summary: 'Success',
          detail: response.message
        });
      },
      error: (error) => {
        this.isLoading = false;
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: error.error.message
        });
      }

    }
    );
  }
}
